module.exports = __webpack_public_path__ + "static/img/preview.1a4af4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/ping-pong-a-thon/preview.png
// module id = 106
// module chunks = 2